import React, { useState } from 'react';

interface ThinkingIndicatorProps {
  thinkingContent?: string;
}

function ThinkingIndicator({
  thinkingContent,
}: ThinkingIndicatorProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="flex flex-col gap-2">
      {/* Animated thinking label */}
      <button
        type="button"
        onClick={() => thinkingContent && setExpanded(!expanded)}
        className={`
          inline-flex items-center gap-2 text-sm text-text-muted
          ${thinkingContent ? 'cursor-pointer hover:text-text-secondary' : 'cursor-default'}
        `}
      >
        {/* Pulsing dots */}
        <span className="flex items-center gap-1">
          <span className="h-1.5 w-1.5 rounded-full bg-primary animate-bounce [animation-delay:0ms]" />
          <span className="h-1.5 w-1.5 rounded-full bg-primary animate-bounce [animation-delay:150ms]" />
          <span className="h-1.5 w-1.5 rounded-full bg-primary animate-bounce [animation-delay:300ms]" />
        </span>
        <span className="font-medium">Thinking...</span>

        {/* Expand/collapse chevron */}
        {thinkingContent && (
          <svg
            className={`h-3 w-3 transition-transform ${expanded ? 'rotate-180' : ''}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        )}
      </button>

      {/* Collapsible thinking content */}
      {expanded && thinkingContent && (
        <div className="rounded-md bg-bg-tertiary border border-border-light p-3 text-sm text-text-muted italic whitespace-pre-wrap">
          {thinkingContent}
        </div>
      )}
    </div>
  );
}

export default React.memo(ThinkingIndicator);
